/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { DepartmentType } from '../models/DepartmentType';
import type { WorkingHoursTrackerDTO } from '../models/WorkingHoursTrackerDTO';
import type { WorkingHoursTrackerFilterResponsePagedListData } from '../models/WorkingHoursTrackerFilterResponsePagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkingHoursTrackerService {

  /**
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkHoursTrackerStart(): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/work-hours-tracker/start',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static putWorkHoursTrackerEnd(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/work-hours-tracker/end',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns number Created
   * @throws ApiError
   */
  public static postWorkHoursTrackerStartBreak(): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/work-hours-tracker/start-break',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static putWorkHoursTrackerEndBreak(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/work-hours-tracker/end-break',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns WorkingHoursTrackerDTO Success
   * @throws ApiError
   */
  public static getWorkHoursTracker(): CancelablePromise<WorkingHoursTrackerDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/work-hours-tracker',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static putWorkHoursTrackerEndScheduler(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/work-hours-tracker/end-scheduler',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param from 
   * @param to 
   * @param employerName 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param department
 *
 * 1 = Sales
 *
 * 2 = Parts
 *
 * 3 = Service
 *
 * 4 = Bodyshop
 *
 * 6 = Admin
 *
 * 7 = BDC
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @returns WorkingHoursTrackerFilterResponsePagedListData Success
   * @throws ApiError
   */
  public static getWorkHoursTrackerTable(
from?: string,
to?: string,
employerName?: string,
branch?: BranchType,
department?: DepartmentType,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
): CancelablePromise<WorkingHoursTrackerFilterResponsePagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/work-hours-tracker/table',
      query: {
        'From': from,
        'To': to,
        'EmployerName': employerName,
        'Branch': branch,
        'Department': department,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

}
